module.exports = __webpack_public_path__ + "static/img/main-slider-1-1.5f08eae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/main-slider-1-1.jpg
// module id = vEK3
// module chunks = 1